/**
 * Transforms snake_case strings into Title Case format with proper capitalization rules
 * @param input A string in snake_case format (e.g., "head_and_neck")
 * @returns The string formatted in Title Case (e.g., "Head and Neck")
 */
export function snakeCaseToTitleCase(input: string): string {
  // List of articles, conjunctions, and prepositions that shouldn't be capitalized
  // unless they're the first or last word
  const minorWords = new Set([
    'a',
    'an',
    'the',
    'and',
    'but',
    'or',
    'for',
    'nor',
    'as',
    'at',
    'by',
    'for',
    'from',
    'in',
    'into',
    'near',
    'of',
    'on',
    'onto',
    'to',
    'with',
  ]);

  // Split the string by underscores
  const words = input.split('_');

  // Process each word according to title case rules
  const result = words.map((word, index) => {
    // Always capitalize the first and last words
    if (index === 0 || index === words.length - 1) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }

    // Check if the word is a minor word
    if (minorWords.has(word)) {
      return word; // Keep minor words lowercase
    }

    // Capitalize other words
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  // Join the words with spaces
  return result.join(' ');
}
